export default "__VITE_ASSET__58097985__"